<template>
	<div class="recursive-divisibility-rules">
		<div class="recursive-divisibility">
			<button class="btn btn-outline-info recursive-toggle fa-2x" @click="show = !show" v-html="buttonText"></button>
			<transition name="slideDown" apear mode="out-in">
				<div class="recursive-content border border-info" v-if="show">
					<DivisibilityRules :terms="terms" />
					<!-- <divisibility-rules :terms="terms" /> -->
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
	import Fnc from 'usefull-functions';
	export default {
		name: 'RecursiveDivisibilityRules',
		props: {
			deep: { default: 0 },
			terms: {type: Array}
		},
		components: {
			DivisibilityRules: () =>  import('./divisibilityRules.vue')
		},
		data() {
			// log('divisibility-rules components:', DivisibilityRules);
			return {
				show: false,
			}
		},
		computed: {
			buttonText() {
				return this.show ?
					("Show less" + Fnc.tag('i', '', {class: 'fa fa-angle-double-left ml-2 fa-2x', style: 'vertical-align: middle'})) :
					("Show more" + Fnc.tag('i', '', {class: 'fa fa-angle-double-right ml-2 fa-2x', style: 'vertical-align: middle'}));
			}
		}
	}
</script>